var exports = {
  "B": "tickle__wt_qUW",
  "K": "copilotRun__YEUB8C",
};

module.exports = exports;
